import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu_icons/Alerte.png'


const _withScopeId = n => (_pushScopeId("data-v-2b526172"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"left","justify-content":"left"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","margin-right":"4px","width":"36px","height":"40px","zoom":"0.7"}
}, null, -1))
const _hoisted_6 = { class: "q-pa-md" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Data si ora")
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_invoice_model = _resolveComponent("invoice-model")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.alerts')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_q_table, {
        grid: _ctx.$q.platform.is.mobile,
        class: "my-sticky-header-table",
        title: "",
        "rows-per-page-options": [0],
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
        rows: _ctx.alerts,
        cols: _ctx.alerts,
        columns: _ctx.columns,
        "visible-columns": _ctx.visibleColumns,
        "row-key": "name",
        flat: "",
        bordered: "",
        "no-data-label": _ctx.$t('message.no_data')
      }, {
        body: _withCtx((props) => [
          _createVNode(_component_q_tr, { props: props }, {
            default: _withCtx(() => [
              _createVNode(_component_q_td, {
                key: "data",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.row.date), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_td, {
                key: "descriere",
                props: props,
                style: {"width":"70%","white-space":"pre-line","word-wrap":"break-word"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: _ctx.processHtml(props.row.description)
                  }, null, 8, _hoisted_7)
                ]),
                _: 2
              }, 1032, ["props"]),
              (_ctx.user.isAdmin == 'y')
                ? (_openBlock(), _createBlock(_component_q_td, {
                    key: "action",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        align: "center",
                        icon: "email",
                        style: {"min-width":"4rem","color":"#9b7d32"},
                        onClick: ($event: any) => (_ctx.resendEmail(props.row.description))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.resend_email')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["props"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        item: _withCtx((props) => [
          _createVNode(_component_q_card, { class: "my_card" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item, {
                    key: "data",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, { caption: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.row.date), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  _createVNode(_component_q_item, {
                    key: "descriere",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.date_and_time')) + ":", 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_label, {
                            caption: "",
                            class: "text-right"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                innerHTML: _ctx.processHtml(props.row.description)
                              }, null, 8, _hoisted_9)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["grid", "pagination", "rows", "cols", "columns", "visible-columns", "no-data-label"]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showAlert,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAlert) = $event)),
        "full-width": _ctx.$q.platform.is.mobile
      }, {
        default: _withCtx(() => [
          _createVNode(_component_invoice_model, { bill_nr: _ctx.bill_nr }, null, 8, ["bill_nr"])
        ]),
        _: 1
      }, 8, ["modelValue", "full-width"])
    ])
  ]))
}